import React, { Component } from "react";
import { observer } from "mobx-react";
import * as APITypes from "constants/API";
import axios from "axios";

import OptimizationStore from "../../modules/optimization/store/OptimizationStore";
import { toJS } from "mobx";
import AllProducts from "./components/amount-calculation/all-product";
import { Button, Dropdown, Image } from "react-bootstrap";
import { calculate_input_values } from "utils/optimization/calculateInputOutputValues";
import chooseProduct from "../comapre-product/utils/choose-product/chooseProduct"
import updateProductDataForCompateProduct from "../comapre-product/utils/choose-product/updateProductDataForCompateProduct"
import { upperCase } from "lodash";
import CashFlowTableModal from "components/ui/cash-flow-table-for-compare-product/CashFlowTableForCompareProduct";
import selectedProduct from "../comapre-product/utils/choose-product/selectedProduct"
import getRecommendedProductData from "../comapre-product/utils/choose-product/getRecommendedProductData"
import "./compare-product.css"
import { RecalculateIcon } from "constants/Images";
import prefillDeathCoverGraphSliderAllAmounts from "utils/forward-reverse-methods/prefillDeathCoverGraphSliderAllAmounts";

const CompareProduct = observer(
    class CompareProduct extends Component {
        constructor(props) {
            super(props);
            this.state = {
                selectedPlan: [],
                activeButton: null,
                selectedProductData: {},
                productBenefitList: ["Premium Break Benefit", "Accrual of Survival Benefits", "Better Half Benefit", "Child future benefit", "Family Income Benefit", "Secondary Life Assured"]
            }
        }

        componentDidMount() {
            getRecommendedProductData()
            this.productBenefit()

        }

        handleSelect = async (chooseProductData) => {
            this.setState({ selectedPlan: chooseProductData })
            await chooseProduct(chooseProductData)

            let recommendProduct = toJS(OptimizationStore.recommendedProductData[0]?.data.package_id)
            let requestObj = {
                "recommend_product_id": recommendProduct,
                "change_product_id": chooseProductData?.package_id
            }
            let response = await axios.post(APITypes.FILTERED_BENEFIR_LIST, requestObj)
            if (response.status === "success") {
                this.setState({ productBenefitList: response.data })
            }

        };
        handleGoBack = () => {
            OptimizationStore.recommendedProductData = []
            this.props.history.push(`/customization/`);
        };

        productBenefit = async () => {
            let response = await axios.get(APITypes.PRODUCT_BENEFIt_MAPPING)
            if (response.status === "success") {
                OptimizationStore.setproductBanefitData(response.data)
            }
        }
        productBenefitMapping = (productBenefit, package_id, benefitName) => {
            const packageData = productBenefit[package_id];
            if (packageData && packageData[benefitName]) {
                return packageData[benefitName] === "N" ? "NO" : packageData[benefitName] === "Y" ? "YES" : "NO"
            }
            return "NO";
        }
        reCalculate = (productData) => {
            updateProductDataForCompateProduct(productData.data.bi_request)
        }
        onSelcetProduct = async (data) => {
            let response = await selectedProduct(data)
            // if (response === "success") {
            this.props.history.push(`/customization/`);
            OptimizationStore.recommendedProductData = []
            // }
        }
        onActiveProduct = (buttonName, data) => {
            this.setState({ activeButton: buttonName })
            this.setState({ selectedProductData: data })
        }
        calculateInputOutputValues = (ProductData) => {

            if (ProductData?.cardKey === "protection_for_my_family") {
                let data = prefillDeathCoverGraphSliderAllAmounts(ProductData?.data)
                return { inputAmount: data.selectedPremium, outputAmt: data.targetValue }
            } else {
                return calculate_input_values(toJS(ProductData?.data))
            }
        }

        render() {
            console.log('historyData>>', toJS(OptimizationStore.recommendedProductData))
            const recommendedProductData = toJS(OptimizationStore.recommendedProductData[0])
            const chooseProductData = toJS(OptimizationStore.recommendedProductData[1])
            let changeProductList = recommendedProductData?.data?.changeProductList
            let inputOutputValues = recommendedProductData ? this.calculateInputOutputValues(recommendedProductData) : ""
            let inputOutputValues2 = chooseProductData ? this.calculateInputOutputValues(chooseProductData) : ""
            let productBanefitData = toJS(OptimizationStore.productBanefitData)
            // const benefitList = ["Premium Break Benefit", "Acrual of survival Benefit", "Better Half Benefit", "Child future benefit"]
            return (
                <>
                    <div className="compare-product-main mt-5  mt-md-1 bg-white py-4">

                        <div className="benefits w-25 mx-2  text-center">
                            <span className="font-size-16 text-primary">Target Income :- {toJS(OptimizationStore.recommendedProductData[0]?.data?.recommended_sum_assured)}</span>
                        </div>
                        <div className="row  mx-2">
                            <div className="col-4 px-1">

                            </div>
                            <div className="col-4 px-1">
                                <div className="">
                                    <Dropdown disabled>
                                        <Dropdown.Toggle variant="" id="dropdown-basic" className="recommend-product-name font-size-14 p-2">
                                            <>
                                                <span className="btn-text-truncate-comapre" >{recommendedProductData?.productName}</span>
                                            </>
                                        </Dropdown.Toggle>
                                    </Dropdown>
                                </div>
                            </div>
                            <div className="col-4 px-1">
                                {changeProductList &&
                                    <div className="">
                                        <Dropdown >
                                            <Dropdown.Toggle variant="" id="dropdown-basic" className="recommend-product-name font-size-14  p-2">
                                                <span className="btn-text-truncate-comapre"> {this.state.selectedPlan.plan_name ? this.state.selectedPlan.plan_name : 'Choose Product'}</span>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="custom-menu-list-compare">
                                                {changeProductList.map(plan => (
                                                    <Dropdown.Item onClick={() => this.handleSelect(plan)} key={plan.id} eventKey={plan.id}>{plan.plan_name}</Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="row mx-2">
                            <div className="col-4 px-1">
                                <div className="bg-secondary text-center my-2 p-2 text-white font-weight-bold">{recommendedProductData?.cardKey != "protection_for_my_family" ? "You Get" : "Protection Cover"}</div>
                            </div>
                            <div className="col-4 px-1">
                                <div className="my-3  text-center benefits">
                                    <span className="font-size-16 text-primary"> {global.toINR(inputOutputValues?.outputAmt)}</span>
                                </div>
                            </div>
                            {chooseProductData?.data &&

                                <div className="col-4 px-1">
                                    <div className="my-3  text-center benefits">
                                        <span className="font-size-16 text-primary"> {global.toINR(inputOutputValues2?.outputAmt)}</span>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="row mx-2">
                            <div className="col-4 px-1">
                                <div className="bg-secondary text-center my-2 p-2 text-white font-weight-bold">{recommendedProductData?.cardKey != "protection_for_my_family" ? "You Pay" : "Modal Premium"}</div>
                            </div>
                            <div className="col-4 px-1">
                                <div className="my-3  text-center benefits">
                                    <span className="font-size-16 text-primary"> {global.toINR(inputOutputValues?.inputAmount)}</span>
                                </div>
                            </div>
                            {chooseProductData?.data &&

                                <div className="col-4 px-1">
                                    <div className="my-3  text-center benefits">
                                        <span className="font-size-16 text-primary"> {global.toINR(inputOutputValues2?.inputAmount)}</span>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="row mx-2">
                            <div className="col-4 px-1">
                                <div className="bg-secondary text-center my-3 p-2 text-white font-weight-bold">{"Policy Term"}</div>
                                <div className="bg-secondary text-center my-3 p-2 text-white font-weight-bold">{"Policy Paying Term"}</div>
                            </div>
                            <div className="col-4 px-1">
                                {recommendedProductData &&
                                    <>


                                        <AllProducts productName={recommendedProductData.productName} data={recommendedProductData} />

                                    </>
                                }
                            </div>
                            <div className="col-4 px-1">
                                {chooseProductData &&
                                    <>


                                        <AllProducts productName={chooseProductData.productName} data={chooseProductData} />
                                    </>
                                }
                            </div>
                        </div>


                        <div className="row mx-2">
                            <div className="col-4 px-1">
                                <div className="bg-secondary text-center my-2 p-2 text-white font-weight-bold">{"CashFlow Table"}</div>
                            </div>
                            {recommendedProductData?.data &&
                                <div className="col-4 px-1">
                                    <div className="my-2  text-center ">
                                        <CashFlowTableModal
                                            productName={recommendedProductData?.data.product_name}
                                            familyProductId={recommendedProductData.data.family_product_id}
                                            // cardName={props.cardName}
                                            productData={recommendedProductData}
                                        />
                                    </div>
                                </div>
                            }
                            {chooseProductData?.data &&

                                <div className="col-4 px-1">
                                    <div className="my-2  text-center">
                                        <CashFlowTableModal
                                            productName={chooseProductData.data.product_name}
                                            familyProductId={chooseProductData.data.family_product_id}
                                            // cardName={props.cardName}
                                            productData={chooseProductData}
                                        />
                                    </div>
                                </div>
                            }
                        </div>

                        {productBanefitData &&
                            <>
                                {this.state.productBenefitList.map((item) => {
                                    return (
                                        <div className="row mx-2">
                                            <div className="col-4 px-1">
                                                <div className="bg-secondary text-center my-2 p-2 text-white font-weight-bold">{item}</div>
                                            </div>
                                            <div className="col-4 px-1">
                                                <div className="my-3  text-center benefits">
                                                    <span className="font-size-16 text-primary"> {this.productBenefitMapping(productBanefitData, recommendedProductData?.data?.package_id, item)}</span>
                                                </div>
                                            </div>
                                            {chooseProductData?.data &&

                                                <div className="col-4 px-1">
                                                    <div className="my-3  text-center benefits">
                                                        <span className="font-size-16 text-primary"> {this.productBenefitMapping(productBanefitData, chooseProductData?.data?.package_id, item)}</span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                                }
                            </>
                        }

                        <div className="row mx-2">
                            <div className="col-4 px-1">

                            </div>
                            <div className="col-4 px-1">
                                {recommendedProductData?.data?.fieldChanged &&
                                    <div className="text-center">
                                        <Button className="btn-danger w-100 font-weight-medium font-size-16 p-1" onClick={() => this.reCalculate(recommendedProductData)}>
                                            <Image
                                                className="pl-2 mb-1"
                                                src={RecalculateIcon}
                                                alt="share-icon"
                                            />{" "}
                                            Recalculate</Button>
                                    </div>
                                }
                            </div>
                            <div className="col-4 px-1">
                                {chooseProductData?.data?.fieldChanged &&
                                    <div className="text-center">
                                        <Button className="btn-danger w-100 font-weight-medium font-size-16 p-1" onClick={() => this.reCalculate(chooseProductData)}>
                                            <Image
                                                className="pl-2 mb-1"
                                                src={RecalculateIcon}
                                                alt="share-icon"
                                            />{" "}
                                            Recalculate
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-4 px-1">

                            </div>
                            <div className="col-4 px-1">
                                {recommendedProductData &&
                                    <div className="text-center">
                                        <Button className="rounded-circle" variant={this.state.activeButton === 'recommened-product' ? 'primary' : 'check-primary'}
                                            onClick={() => { this.onActiveProduct("recommened-product", recommendedProductData.data) }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                                            </svg>
                                        </Button>
                                    </div>
                                }
                            </div>
                            <div className="col-4 px-1">
                                {chooseProductData &&
                                    <div className="text-center">
                                        <Button className="rounded-circle" variant={this.state.activeButton === 'choose-product' ? 'primary' : 'check-primary '}
                                            onClick={() => { this.onActiveProduct("choose-product", chooseProductData.data) }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                                            </svg>
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row  mx-2 mt-4">
                            <div className="col-4 px-1">

                            </div>
                            <div className="col-4 px-1">
                                <Button className="w-100 mx-1 font-weight-bold font-size-14 p-2" onClick={this.handleGoBack} > Back</Button>
                            </div>
                            <div className="col-4 px-1">
                                <Button className="w-100 mx-1 font-weight-bold font-size-14 p-2" onClick={() => { this.onSelcetProduct(this.state.selectedProductData) }} > Submit</Button>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
);
export default CompareProduct;